<template>
  <div style="background-color: #f5f5f5; margin-top: 0.7rem">
    <div class="trading_record_box">
      <div class="left">
        <leftTemplate :left_tabShow="'trading_record'"></leftTemplate>
      </div>
      <div class="right">
        <!-- 素材交易 -->
        <div class="statistics">
          <div>
            <div style="display: flex">
              <div class="statistics_des">余额</div>

              <el-tooltip content="Bottom center" placement="right" effect="customized">
                <div class="quan">?</div>
                <template #content>
                  <div class="quan_text">
                    素材交易余额:{{
                      userObj.materialIn
                      ? (userObj.materialIn / 1).toFixed(2)
                      : 0
                    }}元
                  </div>
                  <!-- <br /> -->
                  <div class="quan_text">
                    业务交易余额
                    {{ userObj.needIn ? (userObj.needIn / 1).toFixed(2) : 0 }}元
                  </div>
                </template>
              </el-tooltip>
            </div>
            <div class="statistics_content">
              {{ userObj.amount ? (userObj.amount / 1).toFixed(2) : 0 }}
              <span style="font-size: 0.14rem">元</span>
            </div>
          </div>
          <div>
            <div class="statistics_des">用户退款</div>
            <div class="statistics_content">
              {{
                userObj.materialOut
                ? (
                  (userObj.needOut / 1).toFixed(2) +
                  (userObj.materialOut / 1).toFixed(2)
                ).toFixed(2)
                : userObj.materialOut
                  ? (
                    (userObj.needOut / 1).toFixed(2) +
                    (userObj.materialOut / 1).toFixed(2)
                  ).toFixed(2)
                  : 0
              }}<span style="font-size: 0.14rem">元</span>
            </div>
          </div>
          <div>
            <div class="statistics_des">累计总收入</div>
            <div class="statistics_content">
              <span style="color: #c01a26">
                {{ userObj.in ? (userObj.in / 1).toFixed(2) : 0 }}</span><span style="font-size: 0.14rem">元</span>
            </div>
          </div>
        </div>
        <div style="
            display: flex;
            border-top: 1px solid #e5e6eb;
            border-bottom: 1px solid #e5e6eb;
            padding-top: 0.2rem;
          ">
          <div class="top_tab" @click="leftGoto('/tradingRecord')">
            素材交易
          </div>
          <div class="top_tab" @click="leftGoto('/tradingRequirement')"
            :class="top_tabShow == 'requirement' ? 'top_tab_select' : ''">
            业务交易
          </div>
        </div>
        <el-table ref="multipleTableRef" :data="tableData" style="width: 100%" height="338">
          <el-table-column property="name" show-overflow-tooltip align="center" label="业务名称">
            <template #default="scope">
              {{ scope.row.orderName }}
            </template>
          </el-table-column>
          <el-table-column label="订单号" align="center" property="orderNo" />
          <el-table-column label="价格" align="center" property="price">
            <template #default="scope">
              <div><span>￥</span>{{ (scope.row.price / 1).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="销售分成" align="center" property="incomePartyB">
            <template #default="scope">
              <div>
                <span>￥</span>{{ (scope.row.incomePartyB / 1).toFixed(2) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="售出时间" align="center" property="payTime">
            <template #default="{ row }">
              {{ row.payTime.split("T").join(" ") }}
            </template>
          </el-table-column>

          <!-- <el-table-column label="成交搜索词" align="center" property="type" /> -->

          <el-table-column label="状态" width="100" align="center" property="type">
            <!-- 0 已付款 1 乙方已二次确认 2 乙方未二次确认四3 已过期 -->
            <template #default="scope">
              <div style="background: #4bc18520; color: #4bc185">
                {{
                  scope.row.state == 0 || scope.row.state == 1 ? "交易成功" : ""
                }}
              </div>
              <div style="background: #ccc; color: #fff">
                {{ scope.row.state == 3 ? "已过期" : "" }}
              </div>
              <div style="background: #ccc; color: #fff">
                {{ scope.row.state == 4 ? "退款成功" : "" }}
              </div>
              <div style="background: #ccc; color: #fff">
                {{ scope.row.state == 5 ? "退款失败" : "" }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div style="display: flex; justify-content: center">
          <el-pagination v-if="tableData.length != 0" v-model:current-page="page.pageNum"
            v-model:page-size="page.pageSize" @size-change="sizeChange" @current-change="currentChange"
            style="margin: 0.4rem 0" background layout="prev, pager, next" :total="page.total" />
        </div>
        <!-- 需求服务 -->
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import leftTemplate from "@/components/leftTemplate.vue";
import { ref } from "vue";
import { ElTable } from "element-plus";

import { Axios } from "@/assets/js/ls_com_axios.js";

const top_tabShow = ref("requirement");

const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event);
};
// 表格

interface User {
  date: string;
  name: string;
  name1: string;
  address: string;
  katype: string;
  price: string;
  number: number;
  time: string;
  orderNumber: string;
  status: number;
}

const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
};
var data = []; // 创建一个空数组

// for (var i = 0; i < 10; i++) {
//   data.push({
//     orderNumber: "45648941615641",
//     name: "黎耀祥·我和我的城《人生有多少个十年》Dir Cut",
//     name1: "广告-餐饮食品·宣传片-国家城市",
//     type: "纪录片",
//     time: "2023-06-08 15:14",
//     katype: 1,
//     faid: "/",
//     number: 34,
//     price: "100",
//     status: "1",
//   }); // 将相同的数据添加到数组中
// }
const tableData = ref([]);

let pageDef = ref({
  pageNum: 1,
  pageSize: 10,
  total: 0,
});
const page = pageDef;
import { useRouter } from "vue-router";
const router = useRouter();
//直接跳转
const leftGoto = (type) => {
  console.log("dianji ", type);
  router.push(type);
};
let form = ref({});
const getList = () => {
  //   console.log(121);
  let obj = {
    keyWord: "",
    pageIndex: page.value.pageNum,
    pageSize: page.value.pageSize,
    orderByColumn: "createTime",
    isAsc: "desc",
    condition: {
      seller_id: JSON.parse(localStorage.getItem("userList")).memberId,
    },
  };
  // JSON.parse(localStorage.getItem("userList")
  Axios(
    "post",
    "/material/material/needOrder/list",
    obj,
    false,
    function (res) {
      console.log();
      if (res.data.code == 200) {
        tableData.value = res.data.data.page.records;
        page.value.total = res.data.data.page.total;
        form.value.BSUM = res.data.data.BSUM;
        form.value.ASUM = res.data.data.ASUM;

        // form.value.totol = res.data.data.records.reduce(
        //   (total, order) => total + order.price,
        //   0
        // );
        // console.log("res.data.data.records", res.data.data.records);
      } else {
        console.log(res);
      }
    }
  );
};
const userObj = ref({});
const getInfo = () => {
  Axios("get", "/member/account-manage/info", false, false, (res) => {
    // myBankList.value = res.data.data;
    // console.log(res.data);
    userObj.value = res.data.data;
  });
};
const sizeChange = (val: number) => {
  console.log(val);
  getList();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  getList();
};
getInfo();
getList();
</script>

<style lang="less">
@import url(/src/assets/css/left_right.css);

.trading_record_box {
  width: 80%;
  margin: 0 auto;
  display: flex;
}

.top_title {
  font-size: 0.14rem;
  margin-bottom: 0.2rem;
  color: #86909c;
}

.top_tab {
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
  color: #333333;
  margin-left: 0.4rem;
  cursor: pointer;
}

.top_tab_select {
  color: #c01a26;
}

.table_information {
  width: calc(100%);
  height: 0.6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.top_tab_select {
  color: #c01a26;
}

// 统计
.statistics {
  display: flex;
  justify-content: space-around;
  padding: 0.2rem 0;
}

.statistics_des {
  font-size: 0.14rem;
}

.statistics_content {
  font-size: 0.24rem;
  margin-top: 0.04rem;
}

/deep/ .el-table th.el-table__cell.is-leaf {
  background: #e3e6ec !important;
}

.quan {
  width: 0.2rem;
  height: 0.2rem;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-left: 3px;
  text-align: center;
  line-height: 0.2rem;
}

.quan_text {
  padding: 5px 0;
  font-size: 15px;
}

// .el-tooltip__popper[x-placement^="right"] .popper__arrow {
//   border-right-color: #1ab394;
// }

.el-popper.is-customized {
  /* Set padding to ensure the height is 32px */
  padding: 6px 12px;
  background: #c01a26;
  color: #fff;
}

.el-popper.is-customized .el-popper__arrow::before {
  background: #c01a26;
  color: #fff;
  right: 0;
}
</style>
